import * as React from 'react';
import {PropsWithChildren, useState} from 'react';
import {useCache} from '../../shared-common/hooks/useCache';
import DataService from '../../shared/services/DataService';
import {AssesseeCache} from '../../shared-common/context/AssesseeCache';
import {AssesseeFilter} from '../../shared-common/types/AssesseeFilter';
import {Assessee} from '../../shared-common/types/Assessee';

export const AssesseeStore = (props: PropsWithChildren<{}>) => {
  const [isProcessing, setIsProcessing] = useState<boolean>();

  const {clearCache, getValue} = useCache<AssesseeFilter, Assessee[]>(
    async (key: AssesseeFilter) => {
      setIsProcessing(true);
      try {
        return await DataService.tryLoad<Assessee[]>(
          '/master-data/get-assessees', {
            datasetIds: key.datasetIds,
            employeeIds: key.employeeIds,
            onlyWithResponses: key.onlyWithResponses
          });
      } finally {
        setIsProcessing(false);
      }
    }
  );

  const getAssessees = (filter: AssesseeFilter) => {
    return getValue(filter);
  };

  const clearAssesseeCache = () => {
    clearCache();
  };

  return (
    <AssesseeCache.Provider
      value={{
        getAssessees: getAssessees,
        clearAssesseeCache: clearAssesseeCache,
        isAssesseeCacheProcessing: isProcessing
      }}
    >
      {props.children}
    </AssesseeCache.Provider>
  );
};
